/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  RDSAzzurroEventsInput,
  RDSAzzurroEventsType,
} from '..';
import {
  serializeRDSAzzurroEventsInput,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface GetRDSAzzurroEventsInput {
  input?: RDSAzzurroEventsInput;
}
const build = (_query: DocumentNode, input: GetRDSAzzurroEventsInput, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }(`+
    ( input.input !== undefined ? `$input: RDSAzzurroEventsInput = ${serializeRDSAzzurroEventsInput(input.input)}` : '' ) + `){
    getRDSAzzurroEvents(
      ${ input.input !== undefined ? 'input: $input,' : '' }
    ){
      ...rdsazzurroeventstype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetRDSAzzurroEventsQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment rdsazzurroeventstype on RDSAzzurroEventsType { ... }
   */
  async execute(_query: DocumentNode, input: GetRDSAzzurroEventsInput, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getRDSAzzurroEvents: Partial<RDSAzzurroEventsType> }>({ query: build(_query, input), fetchPolicy });
  }
}
